import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/app/store/authStore';
import { paths } from '@/app/routes/routePaths';
import { FullPageSpinner } from '@/components/common/FullPageSpinner';

// Gate for "must be logged in". Renders a spinner while session bootstrap
// (the /auth/me call on app load) is in flight, so we never flash the
// login page for an already-authenticated user on refresh.
export function ProtectedRoute() {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();

  if (status === 'idle' || status === 'authenticating') {
    return <FullPageSpinner />;
  }

  if (status === 'unauthenticated') {
    return <Navigate to={paths.login} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
